import toolkitApi, { toolkitSimpleTransform } from '../../toolkitApi';

const endpoint = '/site/api/component-season';

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        componentSeason: build.query({
            query: () => ({
                url: endpoint,
            }),
            transformResponse: toolkitSimpleTransform,
        }),
    }),
});
